var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-card',{staticClass:"placeholder-card"},[_c('div',{staticClass:"placeholder-card-inner"},[_c('ds-placeholder',{attrs:{"rows":[
                { height: '2rem', boxes: [3, 1] },
                { height: '3.5rem', boxes: [1] },
                { height: '3.5rem', boxes: [1] },
            ]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }